import serverCall from "../../serverCall";

const getAll = () => serverCall.get("/master-prompt/getAll");

const getById = (id) => serverCall.get(`/master-prompt/${id}`);

const create = (body) => serverCall.post("/master-prompt/create", body);

const update = (id, body) => serverCall.patch(`/master-prompt/update/${id}`, body);

const remove = (id) => serverCall.delete(`/master-prompt/delete/${id}`);

const MasterPromptService = { getAll, getById, create, update, remove };

export default MasterPromptService;
